import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex justify-center items-center py-12"
};
const _hoisted_2 = {
    key: 1,
    class: "flex flex-col gap-4 overflow-x-hidden"
};
const _hoisted_3 = { class: "flex flex-col gap-1" };
const _hoisted_4 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_5 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft)" };
const _hoisted_6 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default) truncate" };
const _hoisted_7 = { class: "flex flex-col gap-1" };
const _hoisted_8 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_9 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft) min-w-0" };
const _hoisted_10 = { class: "flex flex-col gap-1" };
const _hoisted_11 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_12 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft)" };
const _hoisted_13 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_14 = { class: "flex flex-col gap-1" };
const _hoisted_15 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_16 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft)" };
const _hoisted_17 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_18 = { class: "flex flex-col gap-1" };
const _hoisted_19 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_20 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft)" };
const _hoisted_21 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_22 = { class: "flex flex-col gap-1" };
const _hoisted_23 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_24 = { class: "flex flex-wrap items-center gap-1.5 px-2.5 py-2 min-h-9 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft) dark:bg-(--colors-background-black-default)" };
const _hoisted_25 = {
    key: 1,
    class: "text-sm text-(--text-text-body-subtle)"
};
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { Badge, Drawer, Tooltip } from "@eudonet/opal";
import { INDUSTRY_SECTOR_FALLBACK, normalizeIndustrySector } from "../../domain/industry-sector";
import { useTruncationDetector } from "@/shared/composables/useTruncationDetector";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrganisationPreviewDrawer',
    props: {
        modelValue: { type: Boolean },
        org: {},
        loading: { type: Boolean },
        fallbackTitle: {}
    },
    emits: ["update:modelValue", "go-to-organisation"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const { t } = useI18n();
        const industrySectorLabel = computed(() => {
            const normalized = normalizeIndustrySector(props.org?.industrySector);
            return normalized === INDUSTRY_SECTOR_FALLBACK
                ? t("organisation.detail.options.industrySector.other")
                : normalized;
        });
        const addressText = computed(() => props.org?.address || props.org?.city || "—");
        const locationText = computed(() => [props.org?.city, props.org?.country].filter((part) => !!part && part.trim() !== "").join(", "));
        const addressSpanRef = ref(null);
        const { isTruncated: isAddressTruncated } = useTruncationDetector(addressSpanRef, addressText);
        const emit = __emit;
        const footerActions = computed(() => [
            {
                id: "view-record",
                label: t("organisation.create.dedup.viewRecord"),
                onClick: () => props.org && emit("go-to-organisation", props.org.id),
            },
        ]);
        const EstablishmentNatureThemeMap = {
            Headquarters: "indigo",
            Subsidiary: "purple",
            Branch: "green",
            RepresentativeOffice: "red",
        };
        function getTheme(tag) {
            return EstablishmentNatureThemeMap[tag] ?? "neutral";
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Drawer), {
                "model-value": __props.modelValue,
                position: "right",
                size: "md",
                title: __props.org?.legalName ?? __props.fallbackTitle,
                subtitle: locationText.value || undefined,
                logo: __props.org?.logoUrl ? { src: __props.org.logoUrl, alt: '' } : undefined,
                avatar: __props.org && !__props.org.logoUrl ? { name: __props.org.legalName, entity: 'organisation' } : undefined,
                "aria-label": __props.org || __props.fallbackTitle ? undefined : _ctx.$t('organisation.create.dedup.preview'),
                actions: footerActions.value,
                "aria-close-label": _ctx.$t('common.close'),
                "show-close-button": true,
                "close-on-escape": true,
                dismissable: true,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:modelValue', $event)))
            }, {
                default: _withCtx(() => [
                    (__props.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[1] || (_cache[1] = [
                                _createElementVNode("i", { class: "ri-loader-4-line animate-spin text-2xl text-(--text-text-body-subtle)" }, null, -1 /* CACHED */)
                            ]))]))
                        : (__props.org)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("organisation.create.fields.legalName")), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_5, [
                                        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "ri-building-line text-sm text-(--text-text-body-subtle) shrink-0" }, null, -1 /* CACHED */)),
                                        _createElementVNode("span", _hoisted_6, _toDisplayString(__props.org.legalName), 1 /* TEXT */)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("organisation.create.fields.address")), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_9, [
                                        _cache[3] || (_cache[3] = _createElementVNode("i", { class: "ri-map-pin-2-line text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default) shrink-0" }, null, -1 /* CACHED */)),
                                        _createVNode(_unref(Tooltip), {
                                            text: addressText.value,
                                            disabled: !_unref(isAddressTruncated),
                                            class: "block min-w-0 flex-1"
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("span", {
                                                    ref_key: "addressSpanRef",
                                                    ref: addressSpanRef,
                                                    class: "block w-full text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default) truncate"
                                                }, _toDisplayString(addressText.value), 513 /* TEXT, NEED_PATCH */)
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["text", "disabled"])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("organisation.create.fields.siret")), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("span", _hoisted_13, _toDisplayString(__props.org.primaryRegistrationNumber || "—"), 1 /* TEXT */)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("organisation.detail.mainInformation.organisationType")), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("span", _hoisted_17, _toDisplayString(__props.org.organisationType
                                            ? _ctx.$t(`organisation.detail.options.organisationType.${__props.org.organisationType}`)
                                            : "—"), 1 /* TEXT */)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("organisation.detail.mainInformation.industrySector")), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_20, [
                                        _createElementVNode("span", _hoisted_21, _toDisplayString(industrySectorLabel.value), 1 /* TEXT */)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("organisation.detail.mainInformation.establishmentNature")), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_24, [
                                        (__props.org.establishmentNature)
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.org.establishmentNature.split(','), (tag) => {
                                                return (_openBlock(), _createBlock(_unref(Badge), {
                                                    key: tag.trim(),
                                                    label: _ctx.$t(`organisation.detail.options.establishmentNature.${tag.trim()}`),
                                                    theme: getTheme(tag.trim()),
                                                    size: "sm",
                                                    "show-close-icon": false
                                                }, null, 8 /* PROPS */, ["label", "theme"]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_25, "—"))
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["model-value", "title", "subtitle", "logo", "avatar", "aria-label", "actions", "aria-close-label"]));
        };
    }
});
